import { BannerAlertProps } from "@trustpilot/businessapp-patternlibrary";

import { MakeMessageData, MakeMessageResponse } from "./types";

const makeAllowedMessageType = (type: string): string => {
  const allowedMessageTypeMapping = {
    ProfileViolation1: "ProfileViolation",
    ProfileViolation2: "ProfileViolation",
    WarningBiasedInvitation: "BiasedInvitation",
    WarningBiasedReportingForPersonalInformation: "BiasedReportingForPersonalInformation",
    WarningCeaseAndDesistFabricatedReviews: "CeaseAndDesistFabricatedReviews",
    WarningCherryPicking: "CherryPicking",
    WarningEducationalFabricatedReviews: "EducationalFabricatedReviews",
    WarningFabricatedReviews: "FabricatedReviews",
    WarningFurtherActionFabricatedReviews: "FurtherActionFabricatedReviews",
    WarningIncentiveToChange: "IncentiveToChange",
    WarningIncentiveToWritePositiveReviews: "IncentiveToWritePositiveReviews",
    WarningMisuseOfPublicReplyFunction: "MisuseOfPublicReplyFunction",
    WarningMisuseOfReportingFunction: "MisuseOfReportingFunction",
    WarningProfileViolation1: "ProfileViolation",
    WarningThreatToChangeOrDeleteNegativeReviews: "ThreatToChangeOrDeleteNegativeReviews",
    WarningEducationalMisuseOfReporting: "EducationalMisuseOfReporting",
    WarningWarningMisuseOfReporting: "WarningMisuseOfReporting",
    WarningCeaseAndDesistMisuseOfReporting: "CeaseAndDesistMisuseOfReporting",
    WarningFurtherActionMisuseOfReporting: "FurtherActionMisuseOfReporting",
    EducationalProfileViolation: "EducationalProfileViolation",
    WarningProfileViolation: "WarningProfileViolation",
    CeaseAndDesistProfileViolation: "CeaseAndDesistProfileViolation",
    WarningLegalThreatsTowardReviewer: "WarningLegalThreatsTowardReviewer",
    FurtherActionScammerBusiness: "FurtherActionScammerBusiness",
    EducationalBrandMisuse: "EducationalBrandMisuse",
    CeaseAndDesistBrandMisuse: "CeaseAndDesistBrandMisuse",
    FurtherActionBrandMisuse: "FurtherActionBrandMisuse",
    EducationalFabrication: "EducationalFabrication",
    WarningFabrication: "WarningFabrication",
    CeaseAndDesistFabrication: "CeaseAndDesistFabrication",
    FurtherActionFabricatedReviews: "FurtherActionFabricatedReviews",
  };

  const allowedMessageType:
    | "BiasedInvitation"
    | "BiasedReportingForPersonalInformation"
    | "CeaseAndDesistFabricatedReviews"
    | "CherryPicking"
    | "EducationalFabricatedReviews"
    | "FabricatedReviews"
    | "FabricationByBusinessUser1"
    | "FabricationByBusinessUser2"
    | "IncentiveToChange"
    | "IncentiveToWritePositiveReviews"
    | "MisuseOfReportingFunction"
    | "ProfileViolation"
    | "ThreatToChangeOrDeleteNegativeReviews"
    | "MisuseOfPublicReplyFunction"
    | "EducationalMisuseOfReporting"
    | "WarningMisuseOfReporting"
    | "CeaseAndDesistMisuseOfReporting"
    | "FurtherActionMisuseOfReporting"
    | "EducationalProfileViolation"
    | "WarningProfileViolation"
    | "CeaseAndDesistProfileViolation"
    | "WarningLegalThreatsTowardReviewer"
    | "EducationalBrandMisuse"
    | "CeaseAndDesistBrandMisuse"
    | "FurtherActionBrandMisuse"
    | "FurtherActionScammerBusiness"
    | "EducationalFabrication"
    | "WarningFabrication"
    | "CeaseAndDesistFabrication"
    | "FurtherActionFabricatedReviews" = allowedMessageTypeMapping[type] ? allowedMessageTypeMapping[type] : type;

  return allowedMessageType;
};

const makeMessageData = ({ type, domain, details, locale }: MakeMessageData): MakeMessageResponse => {
  const data = {
    BiasedInvitation: {
      paragraphs: [
        {
          id: "contentIntegrity.BiasedInvitation.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.BiasedInvitation.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://support.trustpilot.com/hc/en-us/articles/207408777" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.BiasedInvitation.paragraph3",
        },
      ],
    },
    CherryPicking: {
      paragraphs: [
        {
          id: "contentIntegrity.CherryPicking.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.CherryPicking.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://support.trustpilot.com/hc/en-us/articles/207408777" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    IncentiveToChange: {
      paragraphs: [
        {
          id: "contentIntegrity.IncentiveToChange.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.IncentiveToChange.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.IncentiveToChange.paragraph3",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://support.trustpilot.com/hc/en-us/articles/115009388547" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    EducationalFabricatedReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.EducationalFabricatedReviews.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalFabricatedReviews.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalFabricatedReviews.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalFabricatedReviews.paragraph4",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "TAKE-LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "TAKE-LINK-END": "</a>",
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    DetectedFabricatedReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.DetectedFabricatedReviews.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.DetectedFabricatedReviews.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.DetectedFabricatedReviews.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.DetectedFabricatedReviews.paragraph4",
        },
        {
          id: "contentIntegrity.DetectedFabricatedReviews.paragraph5",
        },
        {
          id: "contentIntegrity.DetectedFabricatedReviews.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    FabricatedReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.FabricatedReviews.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.FabricatedReviews.paragraph2",
        },
      ],
    },
    CeaseAndDesistFabricatedReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.CeaseAndDesistFabricatedReviews.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabricatedReviews.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabricatedReviews.paragraph3",
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabricatedReviews.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabricatedReviews.paragraph5",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    IncentiveToWritePositiveReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.IncentiveToWritePositiveReviews.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.IncentiveToWritePositiveReviews.paragraph2",
        },
        {
          id: "contentIntegrity.IncentiveToWritePositiveReviews.paragraph3",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.IncentiveToWritePositiveReviews.paragraph4",
        },
      ],
    },
    FabricationByBusinessUser1: {
      paragraphs: [
        {
          id: "contentIntegrity.FabricationByBusinessUser1.paragraph1",
          interpolations: {
            NUMBER: "",
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.FabricationByBusinessUser1.paragraph2",
        },
      ],
    },
    FabricationByBusinessUser2: {
      bannerAlertAppearance: "critical" as BannerAlertProps["appearance"],
      paragraphs: [
        {
          id: "contentIntegrity.FabricationByBusinessUser2.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.FabricationByBusinessUser2.paragraph2",
        },
      ],
    },
    ProfileViolation: {
      paragraphs: [
        {
          id: "contentIntegrity.ProfileViolation.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.ProfileViolation.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.ProfileViolation.paragraph3",
        },
      ],
    },
    MisuseOfReportingFunction: {
      paragraphs: [
        {
          id: "contentIntegrity.MisuseOfReportingFunction.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-reviewers/guidelines-for-reviewers" target="_blank">',
            "LINK-END": "</a>",
            "START-DATE": `<b key="start-date">${
              details
                ? new Date(details.reportingStartDate).toLocaleDateString(locale, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : ""
            }</b>`,
            "END-DATE": `<b key="end-date">${
              details
                ? new Date(details.reportingEndDate).toLocaleDateString(locale, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : ""
            }</b>`,
            COUNT: `<b key="count">${details?.reportedReviewsCount}</b>`,
            "INVALID-COUNT": `<b key="invalid-count">${details?.invalidReportedReviewsCount}</b>`,
          },
        },
        {
          id: "contentIntegrity.MisuseOfReportingFunction.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.MisuseOfReportingFunction.paragraph3",
        },
      ],
    },
    BiasedReportingForPersonalInformation: {
      paragraphs: [
        {
          id: "contentIntegrity.BiasedReportingForPersonalInformation.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.BiasedReportingForPersonalInformation.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.BiasedReportingForPersonalInformation.paragraph3",
        },
      ],
    },
    ThreatToChangeOrDeleteNegativeReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.ThreatToChangeOrDeleteNegativeReviews.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.ThreatToChangeOrDeleteNegativeReviews.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.ThreatToChangeOrDeleteNegativeReviews.paragraph3",
        },
        {
          id: "contentIntegrity.ThreatToChangeOrDeleteNegativeReviews.paragraph4",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://support.trustpilot.com/hc/en-us/articles/115009388547" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    MisuseOfPublicReplyFunction: {
      paragraphs: [
        {
          id: "contentIntegrity.MisuseOfPublicReplyFunction.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.MisuseOfPublicReplyFunction.paragraph2",
        },
      ],
    },
    EducationalMisuseOfReporting: {
      paragraphs: [
        {
          id: "contentIntegrity.EducationalMisuseOfReporting.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalMisuseOfReporting.paragraph2",
          interpolations: {
            "LINK1-BEGIN":
              '<a key="link1" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK2-BEGIN":
              '<a key="link2" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalMisuseOfReporting.paragraph3",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalMisuseOfReporting.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalMisuseOfReporting.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalMisuseOfReporting.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    WarningMisuseOfReporting: {
      paragraphs: [
        {
          id: "contentIntegrity.WarningMisuseOfReporting.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningMisuseOfReporting.paragraph2",
          interpolations: {
            "LINK1-BEGIN":
              '<a key="link1" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "LINK2-BEGIN":
              '<a key="link2" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.WarningMisuseOfReporting.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningMisuseOfReporting.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningMisuseOfReporting.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.WarningMisuseOfReporting.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    CeaseAndDesistMisuseOfReporting: {
      paragraphs: [
        {
          id: "contentIntegrity.CeaseAndDesistMisuseOfReporting.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistMisuseOfReporting.paragraph2",
          interpolations: {
            "LINK1-BEGIN":
              '<a key="link1" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "LINK2-BEGIN":
              '<a key="link2" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistMisuseOfReporting.paragraph3",
          interpolations: {
            "BOLD1-START": '<b key="bold1">',
            "BOLD2-START": '<b key="bold2">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistMisuseOfReporting.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistMisuseOfReporting.paragraph5",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    FurtherActionMisuseOfReporting: {
      paragraphs: [
        {
          id: "contentIntegrity.FurtherActionMisuseOfReporting.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.FurtherActionMisuseOfReporting.paragraph2",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.FurtherActionMisuseOfReporting.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    EducationalProfileViolation: {
      paragraphs: [
        {
          id: "contentIntegrity.EducationalProfileViolation.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalProfileViolation.paragraph2",
        },
        {
          id: "contentIntegrity.EducationalProfileViolation.paragraph3",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalProfileViolation.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalProfileViolation.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalProfileViolation.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    WarningProfileViolation: {
      paragraphs: [
        {
          id: "contentIntegrity.WarningProfileViolation.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningProfileViolation.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link2" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.WarningProfileViolation.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningProfileViolation.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningProfileViolation.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.WarningProfileViolation.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    CeaseAndDesistProfileViolation: {
      paragraphs: [
        {
          id: "contentIntegrity.CeaseAndDesistProfileViolation.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistProfileViolation.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link2" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistProfileViolation.paragraph3",
          interpolations: {
            "BOLD1-START": '<b key="bold1">',
            "BOLD2-START": '<b key="bold2">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistProfileViolation.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistProfileViolation.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
      ],
    },
    WarningLegalThreatsTowardReviewer: {
      paragraphs: [
        {
          id: "contentIntegrity.WarningLegalThreatsTowardReviewer.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningLegalThreatsTowardReviewer.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.WarningLegalThreatsTowardReviewer.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningLegalThreatsTowardReviewer.paragraph4",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningLegalThreatsTowardReviewer.paragraph5",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningLegalThreatsTowardReviewer.paragraph6",
          interpolations: {
            "LINK1-BEGIN":
              '<a key="link1" href="https://legal.trustpilot.com/for-reviewers/guidelines-for-reviewers" target="_blank">',
            "LINK1-END": "</a>",
            "LINK2-BEGIN":
              '<a key="link2" href="https://support.trustpilot.com/hc/en-us/articles/115009388547" target="_blank">',
            "LINK2-END": "</a>",
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
      ],
    },
    FurtherActionScammerBusiness: {
      paragraphs: [
        {
          id: "contentIntegrity.FurtherActionScammerBusiness.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.FurtherActionScammerBusiness.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
      ],
    },
    EducationalBrandMisuse: {
      paragraphs: [
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph2",
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph3",
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
            "LINK1-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/content-refresh-guidelines" target="_blank">',
            "LINK1-END": "</a>",
          },
        },
      ],
    },
    WarningBrandMisuse: {
      paragraphs: [
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph3",
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph5",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph6",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
            "LINK1-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/content-refresh-guidelines" target="_blank">',
            "LINK1-END": "</a>",
          },
        },
      ],
    },
    CeaseAndDesistBrandMisuse: {
      paragraphs: [
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph5",
        },
      ],
    },
    FurtherActionBrandMisuse: {
      paragraphs: [
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
      ],
    },
    EducationalBrandMisuseV2: {
      paragraphs: [
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph2",
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph3",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph5",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph6",
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph7",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalBrandMisuse.paragraph8",
        },
      ],
    },
    WarningBrandMisuseV2: {
      paragraphs: [
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph3",
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph5",
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph6",
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph7",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph8",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph9",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.WarningBrandMisuse.paragraph10",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    CeaseAndDesistBrandMisuseV2: {
      paragraphs: [
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph3",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph5",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistBrandMisuse.paragraph6",
        },
      ],
    },
    FurtherActionBrandMisuseV2: {
      paragraphs: [
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph3",
        },
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.FurtherActionBrandMisuse.paragraph5",
          interpolations: {
            "LINK-BEGIN-1":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/terms-of-use-and-sale-for-businesses" target="_blank">',
            "LINK-BEGIN-2":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-BEGIN-3":
              '<a key="link" href="https://uk.legal.trustpilot.com/for-businesses/legal-brand-guidelines" target="_blank">',
            "LINK-END": "</a>",
          },
        },
      ],
    },
    EducationalFabrication: {
      paragraphs: [
        {
          id: "contentIntegrity.EducationalFabrication.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalFabrication.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.EducationalFabrication.paragraph3",
        },
        {
          id: "contentIntegrity.EducationalFabrication.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.EducationalFabrication.paragraph5",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.EducationalFabrication.paragraph6",
        },
        {
          id: "contentIntegrity.EducationalFabrication.paragraph7",
        },
      ],
    },
    WarningFabrication: {
      paragraphs: [
        {
          id: "contentIntegrity.WarningFabrication.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningFabrication.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.WarningFabrication.paragraph3",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.WarningFabrication.paragraph4",
        },
        {
          id: "contentIntegrity.WarningFabrication.paragraph5",
        },
        {
          id: "contentIntegrity.WarningFabrication.paragraph6",
        },
      ],
    },
    CeaseAndDesistFabrication: {
      paragraphs: [
        {
          id: "contentIntegrity.CeaseAndDesistFabrication.paragraph1",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabrication.paragraph2",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-businesses/guidelines-for-businesses" target="_blank">',
            "LINK-END": "</a>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabrication.paragraph3",
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabrication.paragraph4",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
        {
          id: "contentIntegrity.CeaseAndDesistFabrication.paragraph5",
          interpolations: {
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
      ],
    },
    FurtherActionFabricatedReviews: {
      paragraphs: [
        {
          id: "contentIntegrity.FurtherActionFabricatedReviews.paragraph1",
          interpolations: {
            DOMAIN: `<b key="paragraph">${domain}</b>`,
          },
        },
        {
          id: "contentIntegrity.FurtherActionFabricatedReviews.paragraph2",
          interpolations: {
            "LINK-BEGIN":
              '<a key="link" href="https://legal.trustpilot.com/for-everyone/action-we-take" target="_blank">',
            "LINK-END": "</a>",
            "BOLD-START": '<b key="bold">',
            "BOLD-END": "</b>",
          },
        },
      ],
    },
  };

  return data[type];
};

export { makeMessageData, makeAllowedMessageType };
